import iframeResizer from "iframe-resizer/js/iframeResizer.contentWindow";
import { baseUrl, widget } from "./src/widget";
import uniqid from "uniqid";

const textareaCode = document.querySelector("textarea.widget-code");
const previewContainer = document.querySelector("div.preview");

document.querySelector("form").addEventListener("change", (e) => {
  e.preventDefault();
  const backgroundColor = document.querySelector(
    'input[name="backgroundColor"]',
  ).value;
  const textColor = document.querySelector('input[name="textColor"]').value;
  const buttonBackgroundColor = document.querySelector(
    'input[name="buttonBackgroundColor"]',
  ).value;
  const buttonTextColor = document.querySelector(
    'input[name="buttonTextColor"]',
  ).value;

  const widgetElement = document.createElement("pfaendung-rechner");
  widgetElement.setAttribute("data-background-color", backgroundColor);
  widgetElement.setAttribute("data-text-color", textColor);
  widgetElement.setAttribute(
    "data-button-background-color",
    buttonBackgroundColor,
  );
  widgetElement.setAttribute("data-button-text-color", buttonTextColor);
  widgetElement.setAttribute("data-publisher-id", uniqid.time());

  while (previewContainer.firstChild) {
    previewContainer.removeChild(previewContainer.firstChild);
  }

  previewContainer.appendChild(widgetElement);
  textareaCode.value =
    widgetElement.outerHTML +
    `<script src="${baseUrl}widget.js" async></script>`;

  widget();
});

document.querySelector("form").dispatchEvent(new Event("change"));

iframeResizer; // reference iframe resizer once to prevent tree shaking.
